import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
    padding: 100,
    mobile: {
      desktop: { padding: 100 },
      smartphone: { padding: 20 },
    },
  },
  SECTION_INNER: {
    margin: "0 auto",
  },
  HEADLINE: {
    textAlign: "left",
    fontSize: "28pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    // color: theme.backgroundColor,
    padding: "10px 0",
    mobile: {
      desktop: { fontSize: "28pt" },
      smartphone: { fontSize: "18pt" },
    },
  },
  TEXT: {
    textAlign: "left",
    fontFamily: theme.fontFamily,
    // marginTop: 40,
    // color: theme.backgroundColor,
    fontSize: "14pt",
    padding: "10px 0",
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: 15,
      border: "none",
      backgroundColor: theme.backgroundColor,
      width: "100%",
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "10pt",
    },
  },
  BUTTON_CONTAINER: {
    maxWidth: 350,
    marginTop: 40,
  },
  FORM_FIELD: {
    style: { width: "100%" },
    inputStyle: {
      width: "90%",
      padding: 15,
      backgroundColor: "transparent",
      border: `1px solid ${theme.backgroundColor}`,
      borderRadius: 5,
      color: theme.foregroundColor,
    },
  },
};
